import React from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import OnDemandSigningContainerDetailView from "../components/OnDemandSigningContainerDetailView";
import { canUseOnDemandSigning } from "../utils/organizationFeatures";

const OnDemandSigningContainerDetailPage = () => {
  const { containerId } = useParams();
  const navigate = useNavigate();
  const { organization } = useAuth();

  if (!canUseOnDemandSigning(organization)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <OnDemandSigningContainerDetailView
      containerId={containerId}
      onBack={() => navigate("/dashboard/ondemand-signing")}
      onDeleted={() => navigate("/dashboard/ondemand-signing")}
    />
  );
};

export default OnDemandSigningContainerDetailPage;
